if (!customElements.get('partner-lightbox')) {
  customElements.define(
    'partner-lightbox',
    class PartnerLightbox extends HTMLElement {
      connectedCallback() {
        this.modal = document.getElementById(this.dataset.modalId) || this.querySelector('.ptn-lightbox');
        if (!this.modal) return;

        // Move the popup to <body> so transformed/overflow-hidden ancestors can't clip it.
        if (this.modal.parentNode !== document.body) document.body.appendChild(this.modal);

        this.loop = this.dataset.loop !== 'false';
        this.index = 0;
        this.dialog = this.modal.querySelector('[role="dialog"]');
        this.image = this.modal.querySelector('[data-lightbox-image]');
        this.stage = this.modal.querySelector('[data-lightbox-stage]');
        this.captionEl = this.modal.querySelector('[data-lightbox-caption]');
        this.counterEl = this.modal.querySelector('[data-lightbox-counter]');
        this.prevBtn = this.modal.querySelector('[data-lightbox-prev]');
        this.nextBtn = this.modal.querySelector('[data-lightbox-next]');

        this.onKeydown = this.onKeydown.bind(this);
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.addEventListener('click', this.onTriggerClick);

        this.modal.querySelector('[data-lightbox-close]').addEventListener('click', () => this.close());
        this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.close();
        });

        this.stage.addEventListener(
          'touchstart',
          (event) => {
            this.touchX = event.touches[0].clientX;
          },
          { passive: true }
        );
        this.stage.addEventListener(
          'touchend',
          (event) => {
            if (this.touchX == null) return;
            const delta = event.changedTouches[0].clientX - this.touchX;
            this.touchX = null;
            if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
          },
          { passive: true }
        );
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onTriggerClick);
        document.removeEventListener('keydown', this.onKeydown);
        if (this.modal && this.modal.parentNode) this.modal.remove();
        document.body.classList.remove('overflow-hidden');
      }

      get items() {
        return Array.from(this.querySelectorAll('[data-lightbox-item]'));
      }

      onTriggerClick(event) {
        const trigger = event.target.closest('[data-lightbox-item]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        this.open(this.items.indexOf(trigger), trigger);
      }

      open(index, opener) {
        this.opener = opener;
        const single = this.items.length < 2;
        this.prevBtn.hidden = single;
        this.nextBtn.hidden = single;

        this.go(index, false);
        this.modal.hidden = false;
        this.modal.classList.add('is-visible');
        requestAnimationFrame(() => this.modal.classList.add('is-open'));
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.onKeydown);

        if (typeof window.trapFocus === 'function') {
          window.trapFocus(this.modal, this.dialog);
        } else {
          this.dialog.focus();
        }
      }

      close() {
        if (!this.modal.classList.contains('is-visible')) return;
        this.modal.classList.remove('is-open', 'is-visible');
        this.modal.hidden = true;
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.onKeydown);

        if (typeof window.removeTrapFocus === 'function') {
          window.removeTrapFocus(this.opener);
        } else if (this.opener) {
          this.opener.focus();
        }
      }

      go(index, animate = true) {
        const items = this.items;
        const total = items.length;
        if (!total) return;

        index = this.loop ? (index + total) % total : Math.max(0, Math.min(total - 1, index));
        this.index = index;

        const item = items[index];
        if (item.dataset.srcset) {
          this.image.srcset = item.dataset.srcset;
        } else {
          this.image.removeAttribute('srcset');
        }
        this.image.src = item.dataset.src;
        this.image.alt = item.dataset.alt || '';

        if (animate) {
          this.image.classList.remove('is-changing');
          void this.image.offsetWidth;
          this.image.classList.add('is-changing');
        }

        if (this.captionEl) this.captionEl.textContent = item.dataset.caption || '';
        if (this.counterEl) {
          const pad = (n) => String(n).padStart(2, '0');
          this.counterEl.textContent = `${pad(index + 1)} / ${pad(total)}`;
        }

        if (!this.loop) {
          this.prevBtn.disabled = index === 0;
          this.nextBtn.disabled = index === total - 1;
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      }
    }
  );
}
